package com.deange.nastychristmas.util

import kotlin.js.Date

actual fun now(): Long = Date.now().toLong()
